import request from '@/plugins/request';

export function AccountLogin (data) {
    return request({
        url: '/api/login',
        method: 'post',
        data
    });
}
export function AccountLogout () {
    return request({
        url: '/logout',
        method: 'post',
    });
}
export function AccountRegister (data) {
    return request({
        url: '/api/register',
        method: 'post',
        data
    });
}
